import { FC, PropsWithChildren } from 'react';
import { IOffersHistoryContext, OffersHistoryContext } from '../../context';

export const Provider: FC<PropsWithChildren<IOffersHistoryContext>> = ({ children, ...context }) => {
  return <OffersHistoryContext.Provider value={context}>{children}</OffersHistoryContext.Provider>;
};
